<template>
  <a
    class="bookmark-item-sku__basic-infomation"
    :href="linkUrl"
    @click="clickSkuBasicInformation"
  >
    <ImgLazy
      :image-url="imageUrl"
      :alt-text="itemName"
      aspect-ratio="1 / 1"
      width="80"
      height="80"
      class="bookmark-item-sku__img-container"
    />
    <div class="bookmark-item-sku__info">
      <div class="bookmark-item-sku__item-info">
        <LabelChips :labels="labels" />
        <p class="bookmark-item-sku__brand-name">
          {{ brandName }}
        </p>
        <p class="bookmark-item-sku__item-name">
          {{ itemName }}
        </p>
        <p v-if="itemSkuName" class="bookmark-item-sku__item-sku-name">
          {{ itemSkuName }}
        </p>
      </div>
      <p v-if="outOfStock" class="bookmark-item-sku__out-of-stock-text">
        入荷待ち
      </p>
    </div>
  </a>
</template>
<script>
import ImgLazy from '../images/ImgLazy.vue'
import LabelChips from '../labels/LabelChips.vue'

export default {
  components: {
    ImgLazy,
    LabelChips
  },
  props: {
    imageUrl: {
      type: String,
      required: true
    },
    itemName: {
      type: String,
      required: true
    },
    itemSkuName: {
      type: String,
      required: false,
      default: ''
    },
    brandName: {
      type: String,
      required: true
    },
    itemId: {
      type: Number,
      required: true
    },
    itemSkuId: {
      type: Number,
      required: true
    },
    outOfStock: {
      type: Boolean,
      required: false,
      default: false
    },
    linkUrl: {
      type: String,
      required: false,
      default: null
    },
    labels: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  methods: {
    clickSkuBasicInformation() {
      this.$emit('click-sku-basic-information', this.itemId, this.itemSkuId)
    }
  }
}
</script>
<style lang="scss" scoped>
.bookmark-item-sku {
  &__basic-infomation {
    display: flex;
    max-width: $small-contents-width;
    gap: 16px;
    width: 100%;
    overflow-x: hidden;
  }

  &__img-container {
    border-radius: 8px;
    flex-shrink: 0;
  }

  &__info {
    width: 100%;
    overflow-x: hidden;
  }

  &__item-info {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  &__brand-name {
    @extend %minimal-bold;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__item-name {
    @extend %caption-bold;
    color: $black;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__item-sku-name {
    @extend %caption-bold;
    color: $black;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__out-of-stock-text {
    @extend %caption-bold;
    color: $primary;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-top: 4px;
  }
}
</style>
